import { c as _c } from "react/compiler-runtime";
import { useChartContext } from '#components/chart/context/useChartContext';
import { ProcessedDataPoint } from '#components/chart/types';
type DotSize = 'sm' | 'md';
type DotType = 'real' | 'target';
interface DotConfig {
  innerRadius: number;
  borderWidth: number;
  activeInnerRadius: number;
  activeBorderWidth: number;
}
const DOT_CONFIGS: Record<DotSize, Record<DotType, DotConfig>> = {
  sm: {
    real: {
      innerRadius: 4,
      borderWidth: 3,
      activeInnerRadius: 6,
      activeBorderWidth: 5
    },
    target: {
      innerRadius: 4,
      borderWidth: 0,
      activeInnerRadius: 6,
      activeBorderWidth: 5
    }
  },
  md: {
    real: {
      innerRadius: 6,
      borderWidth: 5,
      activeInnerRadius: 8,
      activeBorderWidth: 7
    },
    target: {
      innerRadius: 6,
      borderWidth: 0,
      activeInnerRadius: 8,
      activeBorderWidth: 7
    }
  }
};
export const ChartDot = props => {
  const $ = _c(12);
  const {
    options: t0
  } = useChartContext();
  const {
    colors,
    size: t1
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const {
    cx,
    cy,
    payload,
    value,
    ignoreValue,
    type: t2
  } = props;
  const type = t2 === undefined ? "real" : t2;
  const isActive = typeof props.isActive === "boolean" ? props.isActive : props.isActive?.(payload) ?? false;
  if (payload?.isInterpolated) {
    return null;
  }
  if (value == null && !ignoreValue) {
    return null;
  }
  const config = DOT_CONFIGS[size][type];
  const innerRadius = isActive ? config.activeInnerRadius : config.innerRadius;
  const borderWidth = isActive ? config.activeBorderWidth : config.borderWidth;
  const svgSize = (innerRadius + borderWidth) * 2;
  const halfSize = svgSize / 2;
  const centerPoint = halfSize;
  let fill = colors.CURRENT_DOT_FILL;
  let stroke = colors.CURRENT_DOTS;
  if (type === "target") {
    fill = isActive ? colors.DOT_FILL : colors.TARGET_DOTS;
    stroke = isActive ? colors.TARGET_ACTIVE_DOT : colors.TARGET_DOTS;
  }
  if (props.ignoreValue) {
    stroke = props.stroke;
    fill = colors.DOT_FILL;
  }
  const t3 = cx - halfSize;
  const t4 = cy - halfSize;
  const t5 = `0 0 ${svgSize} ${svgSize}`;
  let t6;
  if ($[0] !== borderWidth || $[1] !== centerPoint || $[2] !== fill || $[3] !== innerRadius || $[4] !== stroke) {
    t6 = <circle cx={centerPoint} cy={centerPoint} r={innerRadius} fill={fill} stroke={stroke} strokeWidth={borderWidth} />;
    $[0] = borderWidth;
    $[1] = centerPoint;
    $[2] = fill;
    $[3] = innerRadius;
    $[4] = stroke;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== svgSize || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <svg x={t3} y={t4} width={svgSize} height={svgSize} viewBox={t5} fill="none" xmlns="http://www.w3.org/2000/svg">{t6}</svg>;
    $[6] = svgSize;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};